<template lang="">
  <div class="d-flex">
    <!-------------------------------- BLOC PIECES JOINTES-------------------------------->
    <v-col cols="12" sm="10" class="pb-0 mt-10">
      <v-toolbar color="#0B87BA" flat dense>
        <v-col
          cols="12"
          lg="12"
          xl="12"
          class="pa-0 font_color text-left"
        >
          <!-- PIECES JOINTES (à renommer suivant exemple : 3D - 20/09/2021) -->
          <span>PIECES JOINTES</span>

          <v-btn v-if="mode !== 'visualisation' && currentDirectory && currentDirectory.name !== '/'"
              class="btnBold ml-8"
              color="#FF9900"
              dark
              rounded
              @click="addFolderClick(currentDirectory)"
              >
              <v-icon left>
                  fa fa-plus
              </v-icon>
              Ajouter un dossier
          </v-btn>

          <v-btn v-if="mode !== 'visualisation' && currentDirectory && currentDirectory.name !== '/'"
            class="btnBold ml-8"
            color="#FF9900"
            dark
            rounded
            @click="onButtonClick"
          >
            <v-icon left>
                fa fa-plus
            </v-icon>
            Ajouter un fichier
          </v-btn>
          <input ref="uploader" class="d-none" type="file" accept="*" @change="onFileChanged" >
        </v-col>
      </v-toolbar>

      <v-col
        cols="12"
        class="pa-0 font_color text-left"
      >
        <v-breadcrumbs :items="breadcrumbs" divider=">">
          <template v-slot:item="{ item }">
            <v-breadcrumbs-item
              :href="item.href"
              :disabled="item.disabled"
              @click="updateDirectoryToParentFolder()"
            >{{ item.text.toUpperCase() == "SCHÉMAS HYDRAULIQUES" && bloc_fore ? "CAHIER DES CHARGES" : item.text.toUpperCase() }}
            <v-icon v-if="item.home">fa fa-home</v-icon>
            </v-breadcrumbs-item>
          </template>
        </v-breadcrumbs>
      </v-col>

      <div class="folder-flex">
        <div class="folder" v-for="(directory) in directories" :key="directory.name">
          <div class="d-inline">
            <div>
              <img
                alt='updateCurrentDirectory'
                src="@/assets/folder.png"
                @click="updateCurrentDirectory(directory)"
              />
            </div>
            <div class="font-weight-bold" >
              {{ directory.name }}
            </div>
            <div v-if="directory.nb" class="text-caption">Éléments : {{ directory.nb }}</div>
          </div>
        </div>
      </div>
      <br><br>

      <UploaderFiles
        v-if="currentDirectory && currentDirectory.name !== '/'"
        :currentDirectory="currentDirectory"
        @emitFile="fileIsFromDrag = true, onFileChanged($event)"
        :mode="mode"
        ref="UploaderFiles"
      />

      <Popup
        :dialog="addFolderModal"
        text="Nouveau dossier"
        actions="" heightProp="" widthProp="" showClose="false"
        @delete="createDirectory" @nothing="addFolderModal=false"
      >
        <template v-slot:form>
          <v-row>
            <v-col cols="6" offset="3">
              <v-text-field
                label="Dossier"
                placeholder="Dossier"
                outlined
                class="mt-5"
                v-model="newDirectoryName"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" offset="3">
              <span
                style="color: #cc0505"
                v-if="currentDirectory && currentDirectory.children.some(child => child.name === newDirectoryName)">
                <b>Ce nom est déjà utilisé.</b>
              </span>
            </v-col>
            <v-col cols="6" offset="3">
              <v-btn
                class="actions" color="#0B87BA" width="100px" large dark rounded
                @click="createDirectory()"
                :readonly="currentDirectory && currentDirectory.children.some(child => child.name === newDirectoryName)">Créer</v-btn>
              <v-btn class="actions mr-10" color="#0B87BA" width="100px" large dark rounded @click="addFolderModal = false; newDirectoryName = ''">Annuler</v-btn>
            </v-col>
          </v-row>
        </template>
     </Popup>
    </v-col>
  </div>
</template>
<script>import Popup from "@/components/shared/Popup";
import UploaderFiles from "@/components/Clients/UploaderFiles";
import api_doc from "@/api/document";

export default {
  props: {
    project: {
      type: Object,
      required: true,
    },
    filesToAdd: Array,
    bloc_fore: Boolean,
    mode: String,
  },
  components: { Popup, UploaderFiles },
  data() {
    return {
      fileIsFromDrag: false,
      addFolderModal: false,
      selectedFile: null,
      isSelecting: false,
      newDirectoryName: '',
      breadcrumbs: [
        { text: '', disabled: false, home: true },
      ],
      directories: [],
      directoryStack: [],
      currentDirectory: null,
    };
  },
  methods: {
    getNewFiles() {
      const newFiles = [];

      function traverse(directory) {
        for (const file of directory.files || []) {
          if (!file.saved) {
            newFiles.push({
              file: file.fileObject,  // we’ll add this on upload
              name: file.name,
              chemin: file.chemin,
              directory,
            });
          }
        }
        for (const child of directory.children || []) {
          traverse(child);
        }
      }

      traverse(this.project.documents);
      return newFiles;
    },

    addFolderClick() {
      this.addFolderModal = true;
    },

    createDirectory() {
      if (!this.currentDirectory) {
        return;
      }

      if (this.currentDirectory.children.some(child => child.name === this.newDirectoryName)) {
        console.error('Directory name already exists');
        return;
      }

      this.currentDirectory.children.push({
        name: this.newDirectoryName,
        chemin: this.currentDirectory.chemin + '/' + this.newDirectoryName,
        children: [],
        files: [],
        nb: 0,
      });
      this.addFolderModal = false;
      this.newDirectoryName = '';
    },

    onButtonClick() {
      this.isSelecting = true;
      window.addEventListener("focus", () => {
        this.isSelecting = false;
      }, { once: true });

      this.$refs.uploader.click();
    },

    onFileChanged(e) {
      const file = this.fileIsFromDrag ? e : e.target.files[0];
      this.fileIsFromDrag = false;

      if (!this.currentDirectory) {
        return;
      }

      this.currentDirectory.nb++;
      this.currentDirectory.files.push({
        name: file.name,
        chemin: this.currentDirectory.chemin + '/' + file.name,
        saved: false,
        fileObject: file,
      });
    },

    getPayload() {
      return {
        documents: this.project.documents,
        newFiles: this.getNewFiles(),
      };
    },

    updateDirectoryToParentFolder() {
      if (this.directoryStack.length === 0) {
        return;
      }
      const parent = this.directoryStack.pop();
      this.currentDirectory = parent;
      this.directories = parent.children;
      this.breadcrumbs.pop();
    },

    updateCurrentDirectory(directory) {
      this.directoryStack.push(this.currentDirectory);
      this.breadcrumbs.push({ text: directory.name, disabled: true });
      this.currentDirectory = directory;
      this.directories = directory.children;
    },
  },

  created() {
    api_doc
    .getProjectDocuments(this.$route.params.id_projet)
    .then((response) => {
      const folders = response.data;
      const folderRename = {
        'mails_importants': 'Mails Importants',
        'schemas_hydrauliques': 'Schémas hydrauliques',
        'photos': 'Photos',
        'offres_fournisseur': 'Offres fournisseur',
        '_3d_2d': '3D/2D',
        'chiffrages_devis_fta': 'Chiffrages et devis FTA',
        'autres': 'Autres documents',
      };
      folders.children = JSON.parse(folders.children);

      for (const folder of folders.children) {
        if (folderRename[folder.name]) {
          folder.name = folderRename[folder.name];
        }
        folder.chemin = process.env.VUE_APP_BASE_URL + folder.chemin;
        folder.nb = folder.files.length + folder.children.length;
      }

      this.project.documents = folders;
      this.currentDirectory = folders;
      this.directories = folders.children;
    })
    .catch(err => {
      console.error('Failed to load project documents:', err);
    });
  },
};
</script>
<style scoped>
.calendar-field {
  width: 20%;
}

img {
  width: 29px;
  height: 28px;
}

.font_color {
  font-weight: bold;
  color: #ffffff;
}

.width-50 {
  width: 30%;
}

.addPersonne {
  border-style: dashed;
  border-color: blue;
  color: blue;
}

.btnBold {
  font-weight: bold;
}

.errorMsg {
  text-align: left;
  color: red;
  /* margin-bottom: 0.7em;
  margin-top: 0.7em; */
}

::v-deep .v-breadcrumbs__item {
	align-items: center;
	display: inline-flex;
	text-decoration: none;
	transition: .3s cubic-bezier(.25,.8,.5,1);
	color: #FF9900;
}

.active {
  cursor: pointer;
  font-weight: bold;
}
::v-deep .v-breadcrumbs__divider{
  font-weight: bold;
  color: blue!important;
}
.disable{
  font-weight:normal!important
}
.v-breadcrumbs li .v-icon {
	font-size: 16px;
	color: #FF9900;
  cursor: pointer;
}
::v-deep .linkProjet{
  list-style-type:square
 
}
.linkProjet a{
   
    color:#4B4B4B;
 
}
a div:nth-child(2){
  color:#4B4B4B;
  
}
a.linkProjet{
text-decoration:none;
}

.folder {
  cursor: pointer;
}

.folder-flex {
  display: flex;
  flex-direction: row;
  /* justify-content: space-between; */
  gap: 30px;
}
</style>
